export const PROMPT = `

Eres un experto en lengua castellana.
Respeta la acentuación de las palabras.

Vamos a crear un tablero de comunicación con pictogramas para personas con problemas de comunicación oral.
Este tablero va a ayudar a comunicarse al usuario/a con un vocabulario completo y adaptado a la situación o actividad propuesta.
Genera una lista de categorías de palabras para la situación o actividad propuesta.
Devuelve un array con la lista de categorías y los items adecuados.
La estructura debe ser así:
[
  { category: 'xxxx', items: ['aaa', 'bbb', 'ccc'] },
  { category: 'yyyy', items: ['ddd', 'eee'] },
  { category: 'zzzz', items: ['fff', 'ggg'] }
]

A continuación, te mostramos diferentes actividades y las categorías que deberías utilizar para cada una de ellas:
1. MEDICINA Y SALUD
En las actividades relacionadas con la medicina (hospital, consulta, consultorio, etc.), utiliza las siguientes categorías personas (no utilizar cliente y clienta),. profesionales, verbo, síntomas, parte del cuerpo, material médico, procedimiento médico. lugar y adjetivos. 
2. TIENDAS Y SUPERMERCADOS.
En las actividades de tiendas y supermercados, utiliza las siguientes categorías: personas, profesionales, verbos, productos, objetos, cantidad, dinero, lugar.
3. FARMACIA
En las actividades de farmacia, utiliza las siguientes categorías: personas, profesionales (farmacéutica y farmacéutico), verbos, productos, objetos, cantidad, dinero, lugar. En las farmacias no hay pacientes, sino cliente y clienta.
4. VIAJES Y DESPLAZAMIENTOS
En las actividades de viaje y desplazamiento, utiliza las siguientes categorías: personas, familiares (abuelos, abuela, abuelo, tía, tío, prima, primo), verbos, medio de transporte, lugar (oficina de turismo, ...., pero no incluyas monumentos en esta categoría), monumentos de la ciudad, objetos (maleta, equipaje, guía turística, mapa, mochila, dinero, pasaporte, dni, …) tráfico (no incluyas medios de transporte), adjetivos (introduce solamente bien, mal, cerca, lejos, rápido, despacio).
Si el viaje es a Huesca, incluye los siguientes monumentos: San Lorenzo, Las pajaritas, Monasterio de San Juan de la Peña, Castillo de Loarre, Pirineos y pista de esquí.
Si el viaje es a Teruel, incluye los siguientes monumentos: Los Amantes, Plaza del Torico y Torre de San Salvador.
Si el viaje es a Zaragoza, incluye los siguientes monumentos: Pilar, Virgen del Pilar, Catedral de La Seo, César Augusto, Castillo de la Aljafería, Torre del Agua y Monasterio de Piedra.5. 
5. EXCURSIONES
En las actividades de excursión a la granja o al campo, utiliza las siguientes categorías: personas, profesionales (granjera, granjero, agricultora, agricultor, veterinaria, veterinario, profesor, profesora y compañeros), verbos, animales, plantas, objetos, medio de transporte (tractor, autobús, coche, tren, ...), lugar, adjetivos.
En las actividades de excursión a la montaña, utiliza las siguientes categorías: personas, profesionales (profesor, profesora, compañeros), verbos, animales de la montaña, plantas de la montaña, objetos (mochila, cantimplora, botas de montaña, cazadora, chubasquero, brújula, mapa, linterna, ...) medio de transporte, lugar, adjetivos.
6. ALIMENTACIÓN
En actividades relacionadas con un restaurante, utiliza las siguientes categorías: personas, profesionales (camarera, camarero, cocinero, cocinera. ...), verbos, primer plato, segundo plato. postre, bebidas, objetos (incluye menú, factura, propina, mesa, plato, vaso, cuchara, tenedor, cuchillo, servilleta ...), dinero, lugar.
En actividades relacionadas con una cafetería, utiliza las siguientes categorías: personas, profesionales (camarera, camarero), verbos, bebidas, repostería, objetos, dinero, lugar.
En actividades relacionadas con un bar, utiliza las siguientes categorías: personas, profesionales (camarera, camarero), verbos, bebidas, tapas, objetos, dinero, lugar.
7. DEPORTE
En actividades relacionadas con el deporte, utiliza las siguientes categorías: personas, verbos, modalidad deportiva y deportista, material y ropa deportiva,  instalación deportiva, resultado, adjetivos.

REGLAS
En profesionales y adjetivos, utiliza masculino y femenino (por ejemplo, médico, médica, etc.). No utilices médico/a.
En personas, introduce solamente yo, tú, nosotros, mamá, papá, amigos.
En actividades de medicina y salud, no utilices las palabras cliente y clienta.
Las categorías de personas y profesionales van siempre en primer lugar.
En los verbos y acciones, no utilices verbos reflexivos. En vez de sentarse, utiliza sentar.
En dinero, utiliza monedas y billetes de euro. Coloca la palabra euro, euros, céntimo o céntimos detrás del número, según corresponda: 1 euro, 2 euros, etc.. No pongas Moneda de delante de los céntimos.
No utilices personas y profesionales en la categoría de lugares.
No utilices singular y plural de la misma palabra, aunque sea en diferente categorías.
No repitas palabras en diferentes categorías.
El femenino de cliente es clienta.
No utilices moneda, pero utiliza monedas.
Ropa es lo mismo que vestido o vestidos.

`

export const BASEDIR = ''

export const textPositionImages = [
  {
    src: `${BASEDIR}/settings/textPosition/top.png`,
    alt: 'top',
  },
  {
    src: `${BASEDIR}/settings/textPosition/bottom.png`,
    alt: 'bottom',
  },
  {
    src: `${BASEDIR}/settings/textPosition/none.png`,
    alt: 'none',
  },
]

export const blue = '#2196f3'
export const yellow = '#ffeb3b'
export const orange = '#ff9800'
export const green = '#4caf50'
export const grey = '#9e9e9e'
export const purple = '#9c27b0'
export const white = '#ffffff'

export const typeMapping = {
  1: 'properNoun',
  2: 'noun',
  3: 'verb',
  4: 'descriptive',
  5: 'socialContent',
  6: 'miscellaneous',
}

export const TYPES = {
  'PROPER NOUN': 1,
  NOUN: 2,
  VERB: 3,
  ADJECTIVE: 4,
}

export const colorMapping = {
  verb: green,
  descriptive: blue,
  properNoun: yellow,
  noun: orange,
  socialContent: purple,
  miscellaneous: white,
}

export const NoUsedTags = [
  'communication',
  'language',
  'verb',
  'usual verbs',
  'core vocabulary',
  'adjective',
  'qualifying adjective',
]

export const typeColorMapping = {
  3: green,
  4: blue,
  1: yellow,
  2: orange,
  5: purple,
  6: white,
}

export const fontList = [
  // custom Fonts
  'Atkinson-Hyperlegible',
  'Escolar',
  'Massallera',
  'Memima',
  'OpenDyslexic',
  'Pipomayu',

  // 50 Most google fonts use
  'Abel',
  'Abril Fatface',
  'Anton',
  'Archivo',
  'Arimo',
  'Arvo',
  'Asap',
  'Asap Condensed',
  'Assistant',
  'Barlow',
  'Barlow Condensed',
  'Bebas Neue',
  'Bitter',
  'Cabin',
  'Cairo',
  'Catamaran',
  'Caveat',
  'Comfortaa',
  'Cormorant Garamond',
  'Crimson Text',
  'DM Sans',
  'Dancing Script',
  'Dosis',
  'EB Garamond',
  'Exo 2',
  'Fira Sans',
  'Fira Sans Condensed',
  'Fjalla One',
  'Heebo',
  'Hind',
  'Hind Madurai',
  'Hind Siliguri',
  'IBM Plex Mono',
  'IBM Plex Sans',
  'Inconsolata',
  'Inter',
  'Josefin Sans',
  'Jost',
  'Kanit',
  'Karla',
  'Lato',
  'Libre Baskerville',
  'Libre Franklin',
  'Lobster',
  'Lora',
  'M PLUS Rounded 1c',
  'Manrope',
  'Maven Pro',
  'Merriweather',
  'Merriweather Sans',
  'Montserrat',
  'Mukta',
  'Mulish',
  'Nanum Gothic',
  'Noto Color Emoji',
  'Noto Sans',
  'Noto Sans Arabic',
  'Noto Sans JP',
  'Noto Sans KR',
  'Noto Sans SC',
  'Noto Sans TC',
  'Noto Serif',
  'Noto Serif JP',
  'Nunito',
  'Nunito Sans',
  'Open Sans',
  'Oswald',
  'Overpass',
  'Oxygen',
  'PT Sans',
  'PT Sans Narrow',
  'PT Serif',
  'Pacifico',
  'Playfair Display',
  'Poppins',
  'Prompt',
  'Public Sans',
  'Quicksand',
  'Rajdhani',
  'Raleway',
  'Red Hat Display',
  'Righteous',
  'Roboto',
  'Roboto Condensed',
  'Roboto Mono',
  'Roboto Slab',
  'Rubik',
  'Shadows Into Light',
  'Signika Negative',
  'Slabo 27px',
  'Source Code Pro',
  'Space Grotesk',
  'Tajawal',
  'Teko',
  'Titillium Web',
  'Ubuntu',
  'Varela Round',
  'Work Sans',
  'Yanone Kaffeesatz',
  'Zilla Slab',
]
